import type { TomoContent } from '../types/content';
import { TOMO_IMAGES } from './images';

export const tomos: TomoContent[] = [
  {
    number: '01',
    label: 'TOMO 01',
    title: 'DEFENSA Y CONTROL',
    shortDescription:
      'Empuñadura, posición base, split-step, derecha, revés, globo, lectura de paredes, chiquita y defensa en pareja.',
    imageLabel: 'Tomo 1 — Defensa y Control',
    imageUrl: TOMO_IMAGES.tomo1
  },
  {
    number: '02',
    label: 'TOMO 02',
    title: 'ATAQUE Y DEFINICIÓN',
    shortDescription: 'Volea, bandeja, víbora, remate, X3, X4, dejada y sistema de ataque en pareja.',
    imageLabel: 'Tomo 2 — Ataque y Definición',
    imageUrl: TOMO_IMAGES.tomo2
  },
  {
    number: '03',
    label: 'TOMO 03',
    title: 'TÁCTICA Y ESTRATEGIA',
    shortDescription: 'Posicionamiento, toma de decisiones, lectura de juego, rotaciones y sistemas tácticos para pareja.',
    imageLabel: 'Tomo 3 — Táctica y Estrategia',
    imageUrl: TOMO_IMAGES.tomo3
  },
  {
    number: '04',
    label: 'TOMO 04',
    title: 'METODOLOGÍA Y PLANIFICACIÓN',
    shortDescription:
      'Progresiones por nivel, estructura de sesiones, organización de grupos y planificación de temporada.',
    imageLabel: 'Tomo 4 — Metodología y Planificación',
    imageUrl: TOMO_IMAGES.tomo4
  },
  {
    number: '05',
    label: 'TOMO 05',
    title: 'MENTALIDAD, NEGOCIO Y MARCA PERSONAL',
    shortDescription: 'Fidelización de alumnos, gestión de grupos, posicionamiento como monitor y crecimiento profesional.',
    imageLabel: 'Tomo 5 — Mentalidad, Negocio y Marca Personal',
    imageUrl: TOMO_IMAGES.tomo5
  }
];
